module.exports = __webpack_public_path__ + "img/rehman_Advokat_Brynjar_Meling.744f9162.jpg";